import { BookingOrGuest } from '@website/components/BookingCard';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import { CustomerWishlist } from '@website/components/me/userID/CustomerWishlist';
import { useRouter } from 'next/router';
import LoadingPage from '../../../components/utilities/LoadingPage';

export interface BookingsSplitByStatus {
  previousBookings: Array<BookingOrGuest>;
  currentBookings: Array<BookingOrGuest>;
  upcomingBookings: Array<BookingOrGuest>;
  cancelledBookings: Array<BookingOrGuest>;
}

export default function CustomerDashboardPage() {
  const { query } = useRouter();

  if (!query.userID) return <LoadingPage />;

  return (
    <RequiresAuth>
      <CustomerWishlist query={query} />
    </RequiresAuth>
  );
}
